export default {
  state: {},
  mutations: {},
  getters: {},
}
